import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CompanyWalletServiceQueryKeys } from '../../user/constants';
import {
  CreateCompanyDto,
  UserWalletCompanyInfoService,
} from 'services/openapi';

type CreateCompMutationVariables = CreateCompanyDto;

export const useCreateCompMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, CreateCompMutationVariables>({
      mutationFn: (variables: CreateCompMutationVariables) => {
        return UserWalletCompanyInfoService.companyControllerCreateComp(
          variables,
        );
      },
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [CompanyWalletServiceQueryKeys.GET_COMPANY_INFO],
          exact: true,
        }),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
